import { useEffect } from "react"
import MediaHelper from '../../../../lib/helpers/media';
import ImagesApi from '../../../../lib/media/images-api';
import AlertsManager from '../../../../managers/alert/alert-manager';

import { ProceedButton, ViewButton, DeleteButton } from '../../../buttons';

export default ({ img, icon = null, viewDetailsClick, onUseResource, readOnly, onDelete = () => console.log('Image deleted') }) => {
    const handleDelete = () => {
        ImagesApi.deleteImage(img.id).then(() => {
            AlertsManager.success('Image deleted');
            onDelete();
        })
    }

    const download = () => {
        window.open(window.location.href + '/file/' + img?.name);
    }

    return (
        <div class="images-browse__display">
            <div class="images-browse__display-image" style={{ backgroundColor: icon ? 'transparent' : 'black' }}>
                { icon == null ? <div style={{ backgroundImage: `url(${MediaHelper.formatPublicPath(`/images/${img.file_name}`)})` }}></div> : <img src={icon} /> }
            </div>
            <div class="images-browse__display-head">
                <div class="images-browse__display-text">
                    <p>FILE NAME</p>
                    <p>{ img?.name }</p>
                </div>
                { readOnly == null && <button onClick={onUseResource}>Use file</button> }
                {/* <button onClick={viewDetailsClick}>View details</button> */}
                <button onClick={download}>Download</button>
                { readOnly == null && <button onClick={handleDelete}>Delete image</button> }
            </div>
        </div>
    )
}
